import { Icon } from '@iconify/react';
import { Tooltip } from '@mui/material';
import { Text } from './styles';

interface Props {
  placeholder: string;
  tooltipText?: string;
  showTooltip?: boolean;
}

export const InputDescription = ({
  placeholder,
  tooltipText,
  showTooltip = false,
}: Props) => {
  return (
    <Text>
      {placeholder}
      {showTooltip && (
        <Tooltip title={tooltipText} placement="top">
          <Icon
            icon="ri:question-fill"
            width={16}
            height={16}
            color="#005fae"
          />
        </Tooltip>
      )}
    </Text>
  );
};
